module.exports = __webpack_public_path__ + "img/vuejs.4475f80a.svg";